// Shared homepage presentation. The existing slider owns all navigation and answers.
(() => {
  const intake = document.querySelector('#ws-intake weightstart-slider');
  const heroStart = document.querySelector('.hero .ws-orbit-start');
  if (!intake || !heroStart) return;

  function updateIntroduction() {
    const intro = intake.querySelector('.intro-step');
    if (!intro || intro.dataset.localIntro === 'ready') return;
    const heading = intro.querySelector('h3');
    const description = intro.querySelector('.intro-description');
    const action = intro.querySelector('.intro-action');
    const original = action?.querySelector('[data-start-intake]');
    if (!heading || !description || !original) return;
    intro.dataset.localIntro = 'ready';
    original.style.setProperty('display', 'var(--ws-intro-original-display, inline-flex)', 'important');
    heading.textContent = 'Tell us about your goals.';
    description.textContent = 'Share your routine and preferences to help us tailor your plans.';
    intro.querySelector('[role="region"]')?.setAttribute('aria-label', heading.textContent);

    // Keep the original gesture target first for the unchanged touch interface.
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ws-orbit-start';
    button.style.cssText = heroStart.style.cssText;
    button.setAttribute('data-start-intake', '');
    button.setAttribute('aria-label', 'Start questionnaire');
    button.innerHTML = heroStart.innerHTML;
    action.append(button);
  }

  const observer = new MutationObserver(updateIntroduction);
  observer.observe(intake, { childList: true, subtree: true });
  updateIntroduction();
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      observer.observe(intake, { childList: true, subtree: true });
      updateIntroduction();
    }
  });
})();
